import debug from "./isDebug.js";
import { __, sprintf } from "@wordpress/i18n";

const isVowel = (letter) => {
  const vowels = "aeiou";
  return vowels.includes(letter.toLowerCase());
};

const getMorthyMessage = (noun) => {
  // Приводим слово к нижнему регистру для упрощения сравнения
  const lowerNoun = noun.toLowerCase();

  let adjective;
  // Наивное определение рода по конкретным словам
  if (lowerNoun === "имя") {
    // "имя" – средний род
    adjective = "действительное";
  } else if (lowerNoun === "фамилия") {
    // "имя" – средний род
    adjective = "действительную";
    noun = "фамилию";
  } else {
    // Для остальных слов можно задать значение по умолчанию
    adjective = "действительный";
  }

  return { [lowerNoun]: [adjective, noun] };
};
// Ждём, пока появится поле (если оно динамически рендерится) и навешиваем собитие, чтобы контролировать ошибку

const waitForField = (selector, callback) => {
  selector = selector.replaceAll("saphali/", "saphali\\/");
  const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
          observer.disconnect();
          // console.log(`Элемент ${selector} найден, инициализируем React...`);
          callback(element);
      }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
// Функция debounce – возвращает обёртку, которая запускает func через delay миллисекунд после последнего вызова
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}
// Функция для сравнения версий
const isVersionLessThan = (versionA, versionB) => {
  const aParts = versionA.split('.').map(Number);
  const bParts = versionB.split('.').map(Number);

  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
      const a = aParts[i] || 0;
      const b = bParts[i] || 0;
      if (a < b) return true;
      if (a > b) return false;
  }
  return false;
};
// Функция для перестановки DOM-узлов по index
// (обратите внимание: для поля страны можно добавить отдельную логику, если нужно)
const logDebug = (...args) => {
  if (!debug || !args.length) return;


  // Проверяем, последний аргумент - тип ('warn' или 'log')
  const lastArg = args[args.length - 1];
  const consoleMethod = ["warn", "error", "info"].includes(lastArg)
    ? lastArg
    : "log";

  // Если последний - тип, убираем его из массива
  const messages =
    consoleMethod === lastArg ? args.slice(0, -1) : args;

    /* // Получаем имя вызывающей функции  (нулевой элемент стека вызовов)
    const stack = new Error().stack.split("\n");

     // Проверяем, что у нас есть минимум 5 строк
    if (stack.length > 4 ) {
      // Обрежем лишний префикс "    at "
      const line3 = stack[3].trim().replace(/^at /, "");
      const line4 = stack[4].trim().replace(/^at /, "");

      // Пример line3: "Array.forEach (<anonymous>)"
      // Пример line4: "hideSpecifiedFields (http://localhost/...:1352:13)"

      // Достанем отдельно название функции и ссылку
      let funcName = line3.indexOf("http") > 0 ? '' : `${line3} -> `;
      // Ищем паттерн:  ^([^ ]+) \\(([^)]+)\\)$
      //  1-я группа: hideSpecifiedFields
      const match = line4.match(/^([^ ]+) \(([^)]+)\)$/);
      if (match) {
        funcName += `${match[1]} => `; // 'hideSpecifiedFields'
      }
      messages.unshift(funcName);
    } */

    // Выводим сообщение в консоль
  console[consoleMethod](...messages);
};

const reorderFields = (area, fieldsObj, ascending = true) => {
  const areaContainer = document.querySelector(
    `#${area}.wc-block-components-address-form`
  );
  if (!areaContainer) {
    logDebug(`Container for area #${area} not found.`, 'warn');
    return;
  }
  
  const fieldsArray = Object.entries(fieldsObj).map(([key, val]) => ({
    key,
    index: val.index ?? 0,
    type: val.type ?? "text",
    label: val.label || key,
  }));

  fieldsArray.sort((a, b) =>
    ascending ? a.index - b.index : b.index - a.index
  );

  fieldsArray.forEach((field) => {
    field.key = field.key.replaceAll('saphali/', "saphali\\/");
    let selector = `#${area}-${field.key}`;
    
    let inputEl = document.querySelector(selector);
    if (!inputEl) {
      // Если не найден по ID, попробуем найти по классу (например, для некоторых полей)
      inputEl = document.querySelector(
        `.wc-block-components-address-form__${field.key}`
      );
    }
    if (!inputEl) return;

    // Обновляем label и aria-label, если элемент ещё не обновлён
    if (
      inputEl.hasAttribute("aria-label") &&
      inputEl.getAttribute("aria-label") !== field.label
    ) {
      const parentDiv = inputEl.closest("div");
      const labelElement = parentDiv ? parentDiv.querySelector("label") : null;
      if (labelElement) labelElement.innerHTML = field.label;
      inputEl.setAttribute("aria-label", field.label);
      if (!inputEl.classList.contains("saphli-field-control")) {
        // Выбираем существующий инпут по его ID (например, "billing-first_name")
        ((inputElCb) => {
          inputElCb.classList.add("saphli-field-control");
          if (
            inputElCb &&
            inputElCb.hasAttribute("required") &&
            ["input", "select"].includes(inputElCb.nodeName.toLowerCase())
          ) {
            // Добавляем обработчик события blur
            const _event =
              inputElCb.nodeName.toLowerCase() === "input" ? "blur" : "change";
            inputElCb.addEventListener(_event, (event) => {
              const value = event.target.value.trim();
              if (!value) {
                const label = inputElCb
                  .closest("div")
                  .querySelector("label").textContent;
                const an = isVowel(label[0]) ? "an" : "a";
                // Если поле пустое – устанавливаем ошибку через wc/store/validation
                if (label) {
                  setTimeout(() => {
                    // clearInterval(timer);
                    const MorthyMessage = getMorthyMessage(label.toLowerCase());
                    wp.data
                      .dispatch("wc/store/validation")
                      .setValidationErrors({
                        [inputElCb.getAttribute("id").replace("-", "_")]: {
                          message: sprintf(
                            __(
                              "Please enter %s %s",
                              "saphali-woocommerce-lite"
                            ),
                            an,
                            label.toLowerCase()
                          )
                            .replace(
                              "действительный",
                              MorthyMessage[label.toLowerCase()][0]
                            )
                            .replace(
                              label.toLowerCase(),
                              MorthyMessage[label.toLowerCase()][1]
                            ),
                          hidden: false,
                        },
                      });
                  }, 100);
                }

                  logDebug(
                    "Ошибка установлена: " +
                      inputElCb.getAttribute("id").replace("-", "_") +
                      " пустое",
                    label
                  );
              } else {
                // Если значение заполнено – очищаем ошибку
                wp.data
                  .dispatch("wc/store/validation")
                  .clearValidationErrors([
                    inputElCb.getAttribute("id").replace("-", "_"),
                  ]);
                  logDebug(
                    "Ошибка для " +
                      inputElCb.getAttribute("id").replace("-", "_") +
                      " очищена"
                  );
              }
            });
          }
        })(inputEl);
      }
    }

    // Определяем родительский контейнер для перестановки:
    // Для большинства полей ищем по классу, для поля страны (если type === 'country') – отдельно.

    // if (!inputEl) { inputEl = document.querySelector(`.wc-block-components-address-form__${field.key}`); } if (!inputEl) return;
    let parentWrap;
    if (field.type === "country") {
      parentWrap = inputEl.closest(
        `.wc-block-components-address-form__${field.key}`
      );
    } else {
      parentWrap = inputEl.closest(
        `.wc-block-components-address-form__${field.key}`
      );
    }
    logDebug(`Field: ${field.key}, parentWrap:`, parentWrap);
    if (parentWrap && areaContainer.contains(parentWrap)) {
      areaContainer.appendChild(parentWrap);
      logDebug(
        `Reordered field ${field.key} (type=${field.type}, index=${field.index}) in area ${area}`
      );
  }
  });
};
const clearValidationErrorsInField = (selector, area, onlyRemoveRequired = false) => {
  selector = selector.replace(new RegExp(`saphali/`), "saphali\\/");
  waitForField(selector, (field) => {
    // const field = document.querySelector(selector);
    let result = '';
    // console.log('field', field);
    if (field) {
      // console.log('field.hasAttribute("required")', field.hasAttribute("required"));
      if (field.hasAttribute("required")) {
        field.removeAttribute("required");
        result = selector.replace("#", "").replace("-", "_");
        // console.log('result', result);
        
      }
      if (!onlyRemoveRequired) {
        // Скрываем элемент целиком
        if (field.nodeName.toLowerCase() === "span") {
          field.classList.add("hidden-field");
        } else {
          const parentDiv = document.querySelector(`.wc-block-components-address-form__${selector.replace("#" + `${area}-`, "")}`) ? field.closest(`.wc-block-components-address-form__${selector.replace("#" + `${area}-`, "")}`) : field.closest('div');
          if (parentDiv && !(parentDiv.classList.contains('wc-block-components-address-form') || parentDiv.getAttribute('id') === area)) {
            parentDiv.classList.add("hidden-field");
          } else {
            field.classList.add("hidden-field");
          }
          if (field.nodeName.toLowerCase() === 'select' && selector.indexOf('country') > 0 ) {
  
          }
          // if (!field.classList.contains('saphli-field-control')) {
          //   field.classList.add('saphli-field-control');
          //   const _event = field.nodeName.toLowerCase() === 'input' ? 'blur' : field.nodeName.toLowerCase() === 'select' ? 'change' : '';
          //   console.log('field.addEventListener1', _event, selector)
          //   field.addEventListener(_event, (event) => {
          //     const value = event.target.value.trim();
          //     console.log('field.addEventListener', value, _event)
          //     if (!value) {
          //       setTimeout(() => {
          //         wp.data.dispatch('wc/store/validation').clearValidationErrors([field.getAttribute('id').replace('-', '_') ]);
          //       }, 50);
          //     }
          //   });
          // }
          
        }
      }
    }
    return result;
  });
};
const selectedShippingMethod = (select) => {
  // Получаем данные корзины через селектор
  const cartData = select('wc/store/cart')?.getCartData() ?? {};

  // Если нет пакетов доставки — возвращаем пустую строку
  const shippingPackages = cartData.shippingRates;
  if (!shippingPackages?.length) {
    return '';
  }

  // Берем первый пакет доставки
  const { shipping_rates: shippingRates } = shippingPackages[0] || {};
  if (!shippingRates?.length) {
    return '';
  }

  // Ищем выбранный тариф
  const selectedRate = shippingRates.find((rate) => rate.selected);
  return selectedRate?.method_id || 'free_shipping';
};

  const selectedPaymentMethod = (select) => {
    const paymentStore = select('wc/store/payment');
    return paymentStore?.getActivePaymentMethod() || 'cod';
  }
  const PaymentMethodWatcher = () => {
    const activePaymentMethod = useSelect(
      () => wp.data.select('wc/store/payment').getActivePaymentMethod(),
      []
    );
  
    useEffect(() => {
      logDebug('Активный метод оплаты:', activePaymentMethod);
      // Здесь можно выполнить логику, зависящую от выбранного метода оплаты.
    }, [ activePaymentMethod ]);
  
    return null;
  };
  
  // const selectedShippingMethod = () => {
  //   const cartStore = wp.data?.select('wc/store/cart');
  //   const cartData = cartStore?.getCartData() || {};
  //   let selectedShippingMethod = '';
  //   if (cartData?.shippingRates?.length) {
  //     const shippingPackage = cartData.shippingRates[0]; 
  //     if (shippingPackage?.shipping_rates?.length) {
  //       const selectedRateObj = shippingPackage.shipping_rates.find(rate => rate.selected);
  //       if (selectedRateObj) {
  //         selectedShippingMethod = selectedRateObj.method_id || 'free_shipping';
  //       }
  //     }
  //   }
  //   return selectedShippingMethod;
  // }
  // if(typeof wc === 'object') {
  //   const { registerCheckoutFilters } = window.wc.blocksCheckout;

  //   const modifyShowRemoveItemLink = ( defaultValue, extensions, args ) => {
  //     console.log('modifyShowRemoveItemLink', defaultValue, extensions, args);
  //       const isCartContext = args?.context === 'cart';
    
  //       if ( ! isCartContext ) {
  //           return defaultValue;
  //       }
    
  //       return false;
  //   };
    
  //   registerCheckoutFilters( 'saphali-extension', {
  //       showRemoveItemLink: modifyShowRemoveItemLink,
  //   } );
  // }

export { isVowel, getMorthyMessage, waitForField, debounce, reorderFields, clearValidationErrorsInField,
    selectedPaymentMethod, PaymentMethodWatcher, selectedShippingMethod, isVersionLessThan
 };
export default logDebug;